// extracted by mini-css-extract-plugin
module.exports = {"title":"about_title__2reyt","copy":"about_copy__21fRz"};